import React, { useEffect } from 'react';
import { Page, PaymentStatus } from '../../common/constant';
import TransactionService from '../../services/transaction_service';
import { useLocation, useNavigate } from 'react-router-dom';
import { colorError } from '../../shared/theme';
import { useTranslation } from "react-i18next";
import { Button } from 'antd';

/// <summary>
/// Author: Wei Xiang
/// </summary>
const ManualCallback = () => {
    const _transactionService = new TransactionService();
    const _location = useLocation();
    const { amount, paymentMethod, skipPayment } = _location.state || {};
    const _navigate = useNavigate();
    const { t } = useTranslation();

    /// <summary>
    /// Author: Wei Xiang
    /// </summary>
    useEffect(() => {
        if (!skipPayment) {
            const response = {
                title: t("PAYMENT_FAILED"),
                message: t("CONTACT_ADMIN_FOR_HELP"),
                icon: {
                    name: 'times-circle',
                    color: colorError,
                },
            };
            _navigate(Page._PAYMENT_RESULT, { state: { response }, replace: true });
        }
    }, []);

    /// <summary>
    /// Author: Wei Xiang
    /// </summary>
    const callback = async () => {
        const response = await _transactionService.manualCallback({
            amount,
            methodId: paymentMethod?.methodId,
        });

        if (response.data.status === PaymentStatus._SUCCESS || response.data.status === PaymentStatus._FAILED) {
            _navigate(Page._PAYMENT_RESULT, {
                replace: true,
                state: { response }
            });
        }
    }

    return (
        <div style={{ display: 'flex', alignItems: "center", justifyContent: "center", height: "100%" }}>
            <Button type='primary' size="large" onClick={callback}>Callback</Button>
        </div>
    );
};

export default ManualCallback;
